"use strict";
/*
 * Created on 06 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Encapsulates related data of {@link Product product entity} about whether product is new or not.
 *
 * @author JMe
 */


var ProductNewData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductNewData, _DomainObject_1$Domai);

  /**
   * @param productId {@link Product#id}
   * @param flags {@link Product#flags}
   * @param listedAsNewDateFrom {@link Product.newlyListedIntervalStart}
   * @param listedAsNewDateTo {@link Product.newlyListedIntervalEnd}
   * @param active {@link Product.active}
   */
  function ProductNewData(productId, flags, listedAsNewDateFrom, listedAsNewDateTo, active) {
    var _this;

    _classCallCheck(this, ProductNewData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductNewData).call(this));
    _this.productId = productId;
    _this.flags = flags;
    _this.listedAsNewDateFrom = listedAsNewDateFrom;
    _this.listedAsNewDateTo = listedAsNewDateTo;
    _this.active = active;
    return _this;
  }

  return ProductNewData;
}(DomainObject_1.DomainObject);

exports.ProductNewData = ProductNewData;